// extracted by mini-css-extract-plugin
module.exports = {"container":"MenuPage_container__p-bQC","btnContainer":"MenuPage_btnContainer__11Ih2","cardContainer":"MenuPage_cardContainer__1zwg-"};